import { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { getToken } from './api';
import { me, type User } from './auth';
import { LoginScreen } from './LoginScreen';
import { Shell } from './Shell';
import { applyTheme, getTheme } from './theme';

export function App() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    applyTheme(getTheme());
    if (!getToken()) {
      setLoading(false);
      return;
    }
    me()
      .then(setUser)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="shell muted">Загрузка…</div>;
  if (!user) return <LoginScreen onLogin={setUser} />;

  return (
    <BrowserRouter>
      <Shell user={user} onUser={setUser} />
    </BrowserRouter>
  );
}
